import { Button } from "@rumbledirect/ui";
import { Space } from "antd";
import { generateSixDigitNumber } from "../tabs/ClaimDossierCalculationTab";
import { Calculation } from "@rumble-it/common-lib/types/models/Calculation.interface";
import { EyeOutlined } from "@ant-design/icons";

export const calculationColumns = (
  setView: (view: "summary" | "details") => void,
  setSelectedCalculation: (calculation: Calculation | null) => void,
) => [
  {
    title: "Calculatie nummer",
    dataIndex: "id",
    key: "title",
    render: (id: string, record: Calculation) => (
      <span
        onClick={() => {
          setSelectedCalculation(record);
          setView("details");
        }}
        className="font-medium"
      >
        {generateSixDigitNumber(id)}
      </span>
    ),
  },
  {
    title: "Type",
    dataIndex: "calculationIntent",
    key: "calculationIntent",
    render: (calculationIntent: string | null) => {
      return (
        <span className="font-medium">
          {calculationIntent || "Overige calculatie"}
        </span>
      );
    },
  },
  {
    title: "Acties",
    key: "actions",
    dataIndex: "id",
    render: (_: string, record: Calculation) => (
      <Space size="small">
        <Button
          onClick={() => {
            setSelectedCalculation(record);
            setView("details");
          }}
          icon={<EyeOutlined />}
          variant="light"
        />
      </Space>
    ),
  },
];
